import { Box, Flex } from 'mds-web-ui'
import { Link } from 'mds-web-ui/components/Link/GatsbyLink'
import { motion } from 'framer-motion'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import styled from 'styled-components'
import { color, layout, space } from 'styled-system'

import { Paragraph, fontSizes } from '../utils/Typography'
import { useDesktopBreakpoint } from '../utils/mediaQueries'
import { ImageCount } from './ImageCount'

export const FlowCanvas = ({
  href,
  author,
  // description,
  // tags,
  image,
  imageCount,
  title,
  stackedMetadata = false,
  ...props
}) => {
  const isDesktop = useDesktopBreakpoint()
  const showStackedMetadata = !isDesktop || stackedMetadata
  return (
    <StyledLink to={href} {...props}>
      <ImageContainer width="100%">
        <GatsbyImage image={image} alt={title} />
        {!showStackedMetadata ? (
          <ImageMetadata title={title} author={author} />
        ) : null}
        {imageCount > 1 ? (
          <ImageCount
            css={{
              position: 'absolute',
              right: 16,
              bottom: 16
            }}
          >
            {imageCount}
          </ImageCount>
        ) : null}
      </ImageContainer>
      {showStackedMetadata ? (
        <Flex
          width="100%"
          justifyContent="flex-start"
          alignItems="center"
          color="#000"
          px={2}
          gap={2}
          flexWrap="wrap"
          css={{ lineHeight: 1.5 }}
        >
          <Box as="span" css={{ fontWeight: 'bold' }}>
            {title}
          </Box>
          <Box as="span" color="#3a3f42">
            {author}
          </Box>
        </Flex>
      ) : null}
    </StyledLink>
  )
}

const MotionFlex = motion(
  styled(Flex)({
    position: 'absolute',
    opacity: 0,
    inset: 0,
    zIndex: 0,
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%)',
    borderRadius: 16
  })
)

const ImageMetadata = ({ title, author }) => {
  return (
    <MotionFlex
      alignItems="flex-end"
      justifyContent="space-between"
      p="24px"
      whileHover={{ opacity: 1 }}
    >
      <Paragraph animate={false} fontSize={fontSizes.body} color="#fff" m={0}>
        <Box as="span" css={{ fontWeight: 'bold' }}>
          {title}
        </Box>
        {author ? <span>{` by ${author}`}</span> : null}
      </Paragraph>
    </MotionFlex>
  )
}

const StyledLink = styled(Link)(
  {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    textDecoration: 'none',
    '&:hover': {
      opacity: 1
    }
  },
  space,
  layout
)

const ImageContainer = styled('div')(
  {
    justifyContent: 'center',
    borderRadius: 12,
    listStyleType: 'none',
    margin: 0,
    position: 'relative',
    boxShadow: '0 0 0 1px #e5e7e8',

    '> *:first-child': {
      minHeight: 200,
      borderRadius: 'inherit',
      width: '100%'
    }
  },
  space,
  layout,
  color
)
